import { findAll } from "shared/imports/sharedHelperFunctions"

// http://web.archive.org/web/20180317184005/http://patisserie.keensoftware.com:80/en/pages/remove-word-formatting-from-rich-text-editor-with-javascript
// https://github.com/summernote/summernote/issues/303#issuecomment-53713694
export const cleanPastedHTML = ({ input, validStyleDeclarationKeys }) => {
    // 1. remove line breaks / Mso classes
    const stringStripper = /( class=(")?Mso[a-zA-Z]+(")?)/g
    let output = input.replace(stringStripper, "")

    // 2. strip Word generated HTML comments
    const commentSripper = new RegExp("<!--(.*?)-->", "gims")
    output = output.replace(commentSripper, "")

    // 3. remove tags, leave content if any
    let tagStripper = new RegExp("<(/)*(meta|link|\\?xml:|st1:|o:)(.*?)>", "gims")
    output = output.replace(tagStripper, "")

    // 4. remove everything in between and including the tags in badTags
    const badTags = ["applet", "embed", "html", "noframes", "noscript", "script", "style"]
    badTags.forEach((badTag) => {
        tagStripper = new RegExp(`<${badTag}[\\s\\S]*?${badTag}(.*?)>`, "gims")
        output = output.replace(tagStripper, "")
    })

    // 5. remove attributes in badAttributes
    const badAttributes = ["align", "class", "start", "style"]
    badAttributes.forEach((badAttribute) => {
        const attributeStripper = new RegExp(` ${badAttribute}="(.*?)"`, "gims")

        if (badAttribute === "style" && validStyleDeclarationKeys && validStyleDeclarationKeys.length) {
            output = output.replace(
                attributeStripper,
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#specifying_a_function_as_a_parameter
                (match, p1) => {
                    // converts
                    // "color: green; background-color: rgb(0, 0, 255)"
                    // to
                    // ["color: green", "background-color: rgb(0, 0, 255)"]
                    const styleDeclarations = p1.split(";")
                    // keeps track of the valid declarations
                    const validStyleDeclarations = []

                    // loops through styleDeclarations and checks to see which declaration keys
                    // are declared inside of validStyleDeclarationKeys
                    // if there is a match, we push each valid declaration to the validStyleDeclarations array
                    styleDeclarations.forEach((styleDeclaration) => {
                        const declaration = validStyleDeclarationKeys.find((validStyleDeclarationKey) =>
                            RegExp(`^${validStyleDeclarationKey}:`).test(styleDeclaration.trim())
                        )

                        if (declaration) {
                            validStyleDeclarations.push(styleDeclaration.trim())
                        }
                    })

                    if (validStyleDeclarations.length) {
                        return ` style="${validStyleDeclarations.join(";")}"`
                    }

                    return ""
                }
            )
        } else {
            output = output.replace(attributeStripper, "")
        }
    })

    // strip out all <span>...</span> tags which do not have a style attribute
    tagStripper = new RegExp(`<span(?! style).*?>(.*?)</span>`, "gims")
    output = output.replace(tagStripper, "$1")

    // convert any ms word bullets to be <ul><li> elements
    // ms word bullets seem to be in the format
    // <p>(bullet character)[tabs chars]actual text...</p>
    const msWordBullets = new RegExp("<p>·(&nbsp;)+((.|\\n)*?)</p>", "gims")
    const matchingGroups = findAll(msWordBullets, output)
    matchingGroups.forEach((matchGroup) => {
        const bulletContents = matchGroup[2]
        output = output.replace(
            // this is the full match in for the msWordBullets regex in the output
            matchGroup[0],
            `<ul><li>${bulletContents}</li></ul>`
        )
    })

    return (
        output
            // change <p> to <div>
            .replace(/<p/g, "<div")
            .replace(/<\/p>/g, "</div>")
    )
}

export default cleanPastedHTML
